import _ from "lodash";
import client from "lib/apolloClient/client";
import { createAttachmentsMutation } from "Worksheet/modules/WorksheetMutations";

/**
 *
 * @param {*} params
 * @returns Updated attachment object after uploading the file and creating the attachment in the database.
 * @description This function uploads a file to the server and creates an attachment in the database.
 */
export const uploadAndCreateAttachment = async ({
  mode,
  parentId,
  attachment,
  uploadFileV2,
}) => {
  try {
    // * Validate the input parameters
    const parentType =
      mode === "preview" ? null : "QUESTION_SUBMISSION_ATTACHMENT";

    // * Upload the file and get the URL
    const url = await uploadFileV2({
      file: _.get(attachment, "file"),
      attachment: attachment,
      parentType,
      parentId,
    });

    // * Attachment object with cloud URL and metadata
    const attachmentWithUrl = {
      ..._.pick(attachment, ["name", "mimeType", "type", "metadata"]),
      url,
      parentId,
      parentType,
    };

    // * Create attachment and get attachment id
    const uploadedAttachment = await client.mutate({
      mutation: createAttachmentsMutation,
      variables: { input: [attachmentWithUrl] },
    });

    // * Get the created attachment from the response
    const attachmentFile = _.get(
      uploadedAttachment,
      "data.platform.createAttachment.0"
    );

    return attachmentFile;
  } catch (error) {
    // * On error, log it and return null
    return null;
  }
};

/**
 * @param {*} params
 * @returns Placeholder attachment object for video responses.
 * @description This is used to show a placeholder when video loading/uploading.
 */
export const getPlaceholderAttachment = () => {
  return { type: "VIDEO", mimeType: "video/mp4" };
};

/**
 * @param {*} params
 * @returns Styles for the video response field components.
 * @description This styles are based on MediaPlaceholder and CaptureVideo components.
 */
export const getVideoResponseFieldStyles = () => {
  return {
    mediaContainerStyle: {
      width: "100%",
      maxWidth: "100%",
      borderRadius: "8px",
    },
    placeholderContainerStyle: {
      opacity: 0,
      width: "100%",
      maxWidth: "100%",
      borderRadius: "8px",
    },
    customDeleteButtonStyle: {
      top: "8px",
      right: "8px",
      visibility: "visible",
    },
    loaderStyle: {
      top: "50%",
      left: "50%",
      zIndex: 999,
      position: "absolute",
      transform: "translate(-50%, -50%)",
    },
  };
};
